import { Card, Flex, Text, TitledText } from '@/components';
import type { SubsidyRateModel } from '@/features/project/projects/_models/project';
import { useTranslation } from 'react-i18next';
import type { z } from 'zod';

export const SubsidyRateCard = ({
  subsidyRate,
}: {
  subsidyRate: z.infer<typeof SubsidyRateModel>;
}) => {
  const { t } = useTranslation();

  return (
    <Card>
      <Flex gap={16} vertical>
        <Text text={subsidyRate.target} />

        <TitledText title={t('subsidy-rate')} text={subsidyRate.ratesText} />

        <TitledText
          title={t('subsidy-rate-limit-and-so-on')}
          text={subsidyRate.limitText}
        />

        {subsidyRate.url && (
          <TitledText
            title={t('subsidy-rate-url')}
            text={subsidyRate.url}
            href={subsidyRate.url}
            variant="link"
          />
        )}
      </Flex>
    </Card>
  );
};
